import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Carousel, Video } from 'components';
import * as styles from './FBMobilePreview.scss';
var FBMobilePreview = (_dec = connect(function (state) {
  return {
    organization: state.organization.current
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(FBMobilePreview, _Component);

  var _super = _createSuper(FBMobilePreview);

  function FBMobilePreview(props) {
    _classCallCheck(this, FBMobilePreview);

    return _super.call(this, props);
  }

  _createClass(FBMobilePreview, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          adDetails = _this$props.adDetails,
          adType = _this$props.adType,
          fbAcct = _this$props.fbAcct;
      var paddingBottom = '53%';

      if (adType === 'pageLikes') {
        paddingBottom = '37%';
      }

      var style = {
        paddingBottom: paddingBottom
      };

      if (this.props.formatType === 'image') {
        style.backgroundImage = adDetails['image-ad-upload'] && adDetails['image-ad-upload'][0] ? "url(".concat(adDetails['image-ad-upload'][0], ")") : 'url(https://s3.amazonaws.com/likeabucket/user_upload/22/SkfpFgfaX.jpeg)';
      } else if (this.props.formatType === 'carousel') {
        style.backgroundImage = adDetails['carousel-ad-upload'] && adDetails['carousel-ad-upload'][0] ? "url(".concat(adDetails['carousel-ad-upload'][0], ")") : '';
      } else {// TODO video display here
      }

      var videoTags = null;
      var imageTags = null; // SET IMAGE PREVIEW AND/OR CREATE VIDEO TAG

      if (this.props.formatType === 'image') {
        style.backgroundImage = adDetails['image-ad-upload'] && adDetails['image-ad-upload'][0] ? "url(".concat(adDetails['image-ad-upload'][0], ")") : 'url(https://s3.amazonaws.com/likeabucket/user_upload/22/SkfpFgfaX.jpeg)';
      } else if (this.props.formatType === 'video') {
        if (adDetails['video-ad-upload']) {
          if (Array.isArray(adDetails['video-ad-upload'])) {
            videoTags = adDetails['video-ad-upload'].map(function (url, idx) {
              return url.indexOf('blarplesnurf') === -1 || url.indexOf('blarplesnurf-staging') === -1 ? /*#__PURE__*/React.createElement(Video, {
                src: url,
                key: idx,
                style: {
                  width: '100%',
                  height: '100%'
                },
                autoPlay: true,
                loop: true,
                controls: true,
                muted: true
              }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "Your video is being processed. One moment..."), /*#__PURE__*/React.createElement("i", {
                className: "fa fa-spinner fa-spin"
              }));
            });
          }
        }
      } // CREATE TAGS FOR IMAGE OR CAROUSEL


      if (this.props.formatType === 'carousel') {
        imageTags = /*#__PURE__*/React.createElement(Carousel, {
          slides: adDetails['carousel-ad-upload'],
          className: style.img
        });
      } else if (this.props.formatType === 'image') {
        imageTags = /*#__PURE__*/React.createElement("div", {
          className: styles.img,
          style: style
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        style: {
          width: 318,
          margin: '0 auto'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.mobilePreview
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.header
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.headerLogo,
        style: {
          backgroundImage: "url(".concat(fbAcct.avatarImageUrl, ")")
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.headerText
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.headerPageName
      }, this.props.fbAcct.username), /*#__PURE__*/React.createElement("div", {
        className: styles.headerSponsored
      }, "Sponsored", /*#__PURE__*/React.createElement("i", {
        className: "icon ion-earth ".concat(styles.earthIcon)
      }))), this.props.adType === 'pageLikes' && /*#__PURE__*/React.createElement("div", {
        className: styles.headerRight
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-thumbsup ".concat(styles.thumbIcon)
      }))), /*#__PURE__*/React.createElement("div", {
        className: styles.description
      }, adDetails.description), imageTags, videoTags, /*#__PURE__*/React.createElement("div", {
        className: styles.bottom
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.textWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.title
      }, /*#__PURE__*/React.createElement("strong", null, fbAcct.username)), /*#__PURE__*/React.createElement("div", {
        className: styles.subTitle
      }, adDetails.headline)), this.props.adType === 'pageLikes' ? /*#__PURE__*/React.createElement("div", {
        className: styles.fbButtonWrap
      }, /*#__PURE__*/React.createElement("button", {
        className: styles.fbButton
      }, "Like Page")) : /*#__PURE__*/React.createElement("div", {
        className: styles.fbButtonWrap
      }, /*#__PURE__*/React.createElement("button", {
        className: styles.fbButton
      }, "Learn More"))), /*#__PURE__*/React.createElement("img", {
        src: "http://bit.ly/2nsw9nk",
        className: styles.likeThis
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.buttonWrap
      }, /*#__PURE__*/React.createElement("img", {
        src: "http://bit.ly/2nW2MaV"
      })));
    }
  }]);

  return FBMobilePreview;
}(Component), _defineProperty(_class2, "propTypes", {
  organization: PropTypes.object.isRequired
}), _temp)) || _class);
export default FBMobilePreview;